// src/components/ModalOrdenPagoRemitos.jsx
import { useEffect, useMemo, useState } from "react";
import { Modal, Button, Form, Row, Col, Table } from "react-bootstrap";
import moment from "moment";

import { getRemitosPendientesProveedor,getRemitoById } from "../helpers/rutaRemitos";
import { postOrdenPagoRemito } from "../helpers/rutaOrdenPagoRemitos";
import { getSaldosTesoreria } from "../helpers/rutaTesoreria";
import { getCartera } from "../helpers/rutaCarteras"; // 👈 cartera EN_CARTERA
import { generarPDFPendientesProveedor } from "../helpers/pdfPendientesProveedor";
// src/componentes/ModalOrdenPagoRemitos.jsx
// import logoSanPancracio from "../Public/SanPancracio.png"; // 👈 misma ruta que uses en Remitos


const $ = (n) =>
  Number(n || 0).toLocaleString("es-AR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

const IVA_105 = 1.105;

const fmtFechaDoc = (d) => (d ? moment.utc(d).format("DD/MM/YYYY") : "-");

const LOGO_SAN_PANCRACIO = "/SanPancracio.png";

function calcularTotalesRemito(rem) {
  let totalA = Number(rem.totalCompraA || 0);   // blanco + IVA
  let totalB = Number(rem.totalCompraB || 0);   // negro
  let flete  = Number(rem.flete || 0);

  const kg   = Number(rem.kgRecibido || 0);
  const pc   = Number(rem.precioCompra || 0);
  const base = rem.totalCompra != null
    ? Number(rem.totalCompra || 0)
    : kg * pc;

  // Si no vienen A y B, los recalculo con porcentajeCompra
  if (totalA <= 0.01 && totalB <= 0.01 && base > 0) {
    const porcB = Number(rem.porcentajeCompra || 0) / 100; // % negro
    const compraNegro      = base * porcB;
    const compraBlancoBase = base - compraNegro;
    const compraBlancoIVA  = compraBlancoBase * IVA_105;

    totalA = compraBlancoIVA;
    totalB = compraNegro;
  }

  return { totalA, totalB, flete };
}

export default function ModalOrdenPagoRemitos({
  show,
  onHide,
  proveedor,
  cliente = null,
  preseleccion = [],
}) {
  const [fecha, setFecha] = useState(moment().format("YYYY-MM-DD"));
  const [obs, setObs] = useState("");

  const [pendientes, setPendientes] = useState([]);
  const [seleccion, setSeleccion] = useState([]);

  const [filtrarCliente, setFiltrarCliente] = useState(false);

  // 👇 NUEVO: qué conceptos se pagan
  const [pagaA, setPagaA] = useState(false);        // Compra A (blanco)
  const [pagaB, setPagaB] = useState(false);        // Compra B (negro)
  const [pagaFlete, setPagaFlete] = useState(false); // Flete

  // pagos / retenciones
  const [medios, setMedios] = useState([]);
  const [rets, setRets] = useState([]);

  // combos tesorería
  const [cajas, setCajas] = useState([]);
  const [cuentas, setCuentas] = useState([]);

  // cartera
  const [carteraCheques, setCarteraCheques] = useState([]);
  const [carteraICheqs, setCarteraICheqs] = useState([]);


  // ------------- totales pendientes proveedor -------------
  const totalesPendientes = pendientes.reduce(
    (acc, r) => {
      const pendA = Number(
        r.pendienteA ??
        Math.max(0, Number(r.totalCompraA || 0) - Number(r.pagadoA || 0))
      );
      const pendB = Number(
        r.pendienteB ??
        Math.max(0, Number(r.totalCompraB || 0) - Number(r.pagadoB || 0))
      );
      const pendF = Number(
        r.pendienteFlete ??
        Math.max(0, Number(r.flete || 0) - Number(r.pagadoFlete || 0))
      );

      const saldo = Number((pendA + pendB + pendF).toFixed(2));

      acc.compraA += pendA;
      acc.compraB += pendB;
      acc.flete   += pendF;
      acc.saldo   += saldo;
      return acc;
    },
    { compraA: 0, compraB: 0, flete: 0, saldo: 0 }
  );


  // DEBUG (podés dejarlos un ratito y después sacarlos)
  console.log("▶ pendientes resumen:", pendientes);
  console.log("▶ totalesPendientes:", totalesPendientes);


  // ------------- totales -------------
  // Σ selección: suma de saldos pendientes (como antes)
  const totalSeleccion = useMemo(
    () => seleccion.reduce((a, r) => a + Number(r.saldo || 0), 0),
    [seleccion]
  );
  const totalPagos = useMemo(
    () => medios.reduce((a, m) => a + Number(m.importe || 0), 0),
    [medios]
  );
  const totalRets = useMemo(
    () => rets.reduce((a, r) => a + Number(r.importe || 0), 0),
    [rets]
  );

  const montoAplicable = useMemo(
    () => Math.max(0, Number(totalPagos) - Number(totalRets)),
    [totalPagos, totalRets]
  );

  const aplicacionesDistribuidas = useMemo(() => {
    let restante = montoAplicable;
    const orden = [...seleccion].sort(
      (a, b) => new Date(a.fecha || 0) - new Date(b.fecha || 0)
    );

    const apps = [];

    for (const r of orden) {
      if (restante <= 0.01) break;

      // Pendientes reales por concepto
      const pendAFull = Number(
        r.pendienteA ??
        Math.max(0, Number(r.totalCompraA || 0) - Number(r.pagadoA || 0))
      );
      const pendBFull = Number(
        r.pendienteB ??
        Math.max(0, Number(r.totalCompraB || 0) - Number(r.pagadoB || 0))
      );
      const pendFFull = Number(
        r.pendienteFlete ??
        Math.max(0, Number(r.flete || 0) - Number(r.pagadoFlete || 0))
      );

      const saldoTotal = Number((pendAFull + pendBFull + pendFFull).toFixed(2));
      if (saldoTotal <= 0.01) continue;

      // Según lo que elija el usuario
      let pendienteA = pagaA ? pendAFull : 0;
      let pendienteB = pagaB ? pendBFull : 0;
      let pendienteF = pagaFlete ? pendFFull : 0;

      const totalPendConceptos = pendienteA + pendienteB + pendienteF;
      if (totalPendConceptos <= 0.01) continue; // no hay nada para este remito

      let restanteRemito = Math.min(saldoTotal, restante);
      let aplicadoA = 0;
      let aplicadoB = 0;
      let aplicadoF = 0;

      // Prioridad de imputación: A → B → Flete
      const conceptos = [
        { key: "A", max: pendienteA },
        { key: "B", max: pendienteB },
        { key: "F", max: pendienteF },
      ];

      for (const c of conceptos) {
        if (restanteRemito <= 0.01) break;
        if (c.max <= 0.01) continue;

        const usar = Math.min(c.max, restanteRemito);

        if (c.key === "A") aplicadoA += usar;
        else if (c.key === "B") aplicadoB += usar;
        else aplicadoF += usar;

        restanteRemito -= usar;
      }

      const aplicadoTotal = aplicadoA + aplicadoB + aplicadoF;
      if (aplicadoTotal <= 0.01) continue;

      apps.push({
        remito: r._id,
        aplicado: aplicadoTotal,
        aplicadoA,
        aplicadoB,
        aplicadoFlete: aplicadoF,
      });

      restante -= aplicadoTotal;
    }

    return { apps, restante };
  }, [seleccion, montoAplicable, pagaA, pagaB, pagaFlete]);


  const diferenciaVisual = useMemo(
    () => (totalSeleccion - montoAplicable).toFixed(2),
    [totalSeleccion, montoAplicable]
  );

  const handlePdfPendientes = () => {
    generarPDFPendientesProveedor({
      proveedor,
      cliente: filtrarCliente ? cliente : null,
      pendientes,
      totales: totalesPendientes,
      fecha,
      logoUrl: LOGO_SAN_PANCRACIO,   // 👈 acá usamos la URL del logo
      empresa: {
        nombre: "SAN PANCRACIO SRL",
        direccion:
          "Avda. Peron 1600 - Oficina 29 Piso 1 - Yerba Buena - Tucumán",
        telefono: "Tel: 0381-3008829",
        email: "contacto@sanpancracio.com",
      },
    }).catch((err) => {
      console.error("Error generando PDF de pendientes:", err);
      alert("No se pudo generar el PDF de pendientes.");
    });
  };

  // ----------- cargar data -----------
  useEffect(() => {
    if (!show || !(proveedor?._id || proveedor)) return;

    (async () => {
      // 1) Pendientes del proveedor / cliente
      const baseList = await getRemitosPendientesProveedor(
        proveedor?._id || proveedor,
        filtrarCliente ? (cliente?._id || cliente) : undefined
      );

      // 2) Para cada remito, traigo el detalle completo y recalculo A/B/Flete
      const list = await Promise.all(
        (baseList || []).map(async (r) => {
          try {
            const resp = await getRemitoById(r._id);
            const rem = resp?.remito || resp || {};
            const { totalA, totalB, flete } = calcularTotalesRemito(rem);

            const pagadoA = Number(rem.pagadoA || 0);
            const pagadoB = Number(rem.pagadoB || 0);
            const pagadoFlete = Number(rem.pagadoFlete || 0);
            const pagadoProv = Number(rem.pagadoProveedor || 0);

            const pendienteA = Math.max(0, totalA - pagadoA);
            const pendienteB = Math.max(0, totalB - pagadoB);
            const pendienteFlete = Math.max(0, flete - pagadoFlete);
            const saldoPendiente = Number(
              (pendienteA + pendienteB + pendienteFlete).toFixed(2)
            );

            return {
              ...r,
              totalCompraA: totalA,
              totalCompraB: totalB,
              flete,
              pagadoProveedor: pagadoProv,
              pagadoA,
              pagadoB,
              pagadoFlete,
              pendienteA,
              pendienteB,
              pendienteFlete,
              saldoPendiente,
            };
          } catch (err) {
            console.error("Error cargando detalle remito", r._id, err);
            return {
              ...r,
              totalCompraA: 0,
              totalCompraB: 0,
              flete: 0,
              pagadoProveedor: 0,
              pagadoA: 0,
              pagadoB: 0,
              pagadoFlete: 0,
              pendienteA: 0,
              pendienteB: 0,
              pendienteFlete: 0,
              saldoPendiente: 0,
            };
          }
        })
      );

      // 3) Ordeno por fecha
      const ordenadas = (list || [])
        .slice()
        .sort((a, b) => new Date(a.fecha || 0) - new Date(b.fecha || 0));

      // 4) Reconstruyo selección con los nuevos datos
      const map = new Map(ordenadas.map((r) => [r._id, r]));
      const seed = [
        ...preseleccion,
        ...seleccion.filter((x) => map.has(x._id)),
      ];

      const sel = [];
      seed.forEach((s) => {
        const r = map.get(s._id);
        if (!r) return;

        const pendA = Number(
          r.pendienteA ??
            Math.max(0, Number(r.totalCompraA || 0) - Number(r.pagadoA || 0))
        );
        const pendB = Number(
          r.pendienteB ??
            Math.max(0, Number(r.totalCompraB || 0) - Number(r.pagadoB || 0))
        );
        const pendF = Number(
          r.pendienteFlete ??
            Math.max(0, Number(r.flete || 0) - Number(r.pagadoFlete || 0))
        );

        const saldo = Number((pendA + pendB + pendF).toFixed(2));
        if (saldo > 0.01) sel.push({ ...r, saldo });
      });

      setPendientes(ordenadas);
      setSeleccion(sel);

      // 5) Saldos tesorería
      try {
        const s = await getSaldosTesoreria();
        if (s?.ok) {
          setCajas(Array.isArray(s.cajas) ? s.cajas : []);
          setCuentas(Array.isArray(s.cuentas) ? s.cuentas : []);
        }
      } catch (err) {
        console.error("Error cargando saldos tesorería", err);
      }

      // 6) Cartera EN_CARTERA
      try {
        const res = await getCartera({ estado: "EN_CARTERA" });
        const items = res?.items || res?.cartera || res || [];
        setCarteraCheques(items.filter((x) => x.tipo === "CHEQUE"));
        setCarteraICheqs(items.filter((x) => x.tipo === "ICHEQ"));
      } catch (err) {
        console.error("Error cargando cartera", err);
        setCarteraCheques([]);
        setCarteraICheqs([]);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show, proveedor?._id, cliente?._id, filtrarCliente]);


  // ----------- selección -----------
  const toggle = (r) => {
    setSeleccion((prev) => {
      const ex = prev.find((x) => x._id === r._id);
      if (ex) return prev.filter((x) => x._id !== r._id);

      const pendA = Number(r.pendienteA ?? 0);
      const pendB = Number(r.pendienteB ?? 0);
      const pendF = Number(r.pendienteFlete ?? 0);
      const saldo = Number((pendA + pendB + pendF).toFixed(2));

      return saldo > 0.01 ? [...prev, { ...r, saldo }] : prev;
    });
  };

  const tildarTodas = () =>
    setSeleccion(
      pendientes
        .map((r) => {
          const pendA = Number(r.pendienteA ?? 0);
          const pendB = Number(r.pendienteB ?? 0);
          const pendF = Number(r.pendienteFlete ?? 0);
          const saldo = Number((pendA + pendB + pendF).toFixed(2));
          return { ...r, saldo };
        })
        .filter((r) => r.saldo > 0.01)
    );

  const destildarTodas = () => setSeleccion([]);

  // ----------- pagos / rets -----------
  const addMedio = (m) => setMedios((p) => [...p, m]);
  const rmMedio = (i) => setMedios((p) => p.filter((_, idx) => idx !== i));
  const addRet = (r) => setRets((p) => [...p, r]);
  const rmRet = (i) => setRets((p) => p.filter((_, idx) => idx !== i));

  const saldoWarnings = useMemo(() => {
    const w = [];
    medios.forEach((m, i) => {
      const imp = Number(m.importe || 0);
      if (m.medio === "efectivo") {
        const cx = cajas.find((c) => String(c._id) === String(m.caja));
        const s = Number(cx?.saldoActual || 0);
        if (!m.caja) w.push(`Pago #${i + 1}: seleccione una Caja.`);
        if (imp > s + 0.0001)
          w.push(
            `Pago #${i + 1}: importe supera saldo de caja (${s.toLocaleString(
              "es-AR"
            )}).`
          );
      }
      if (m.medio === "transferencia") {
        const ct = cuentas.find(
          (c) => String(c._id) === String(m.cuentaBancaria)
        );
        const s = Number(ct?.saldoActual || 0);
        if (!m.cuentaBancaria)
          w.push(`Pago #${i + 1}: seleccione una Cuenta.`);
        if (imp > s + 0.0001)
          w.push(
            `Pago #${i + 1}: importe supera saldo de cuenta (${s.toLocaleString(
              "es-AR"
            )}).`
          );
      }
    });
    return w;
  }, [medios, cajas, cuentas]);

  const canSubmit =
    seleccion.length > 0 && totalPagos > 0 && montoAplicable > 0;

  // ----------- guardar -----------
  const guardar = async () => {
    try {
      if (!canSubmit) return;

      if (saldoWarnings.length > 0) {
        const seguir = window.confirm(
          "Hay advertencias:\n- " +
            saldoWarnings.join("\n- ") +
            "\n\n¿Deseás continuar de todas formas?"
        );
        if (!seguir) return;
      }

      const payload = {
        proveedor: proveedor?._id || proveedor,
        cliente: filtrarCliente ? (cliente?._id || cliente) : undefined,
        fecha,
        observaciones: obs,
        aplicaciones: aplicacionesDistribuidas.apps,
        pagos: medios.map((m) => {
          const base = {
            medio: m.medio,
            importe: Number(m.importe || 0),
            referencia: m.referencia || m.nroCheque || "",
          };

          if (m.medio === "efectivo") {
            return { ...base, caja: m.caja };
          }

          if (m.medio === "transferencia") {
            return { ...base, cuentaBancaria: m.cuentaBancaria };
          }

          if (m.medio === "cheque" || m.medio === "icheq") {
            // 👇 ACÁ ESTÁ EL PROBLEMA
            return { ...base, carteraId: m.carteraId || null };
          }

          return base;
        }),

        retenciones: rets.map((r) => ({
          tipo: (r.tipo || "IIBB").toUpperCase(),
          base: Number(r.base || 0),
          porcentaje: Number(r.porcentaje || 0),
          importe: Number(r.importe || 0),
          comprobante: r.comprobante || "",
        })),
      };

      const res = await postOrdenPagoRemito(payload);
      if (res?.ok) {
        alert("Orden de pago guardada correctamente.");
        onHide(true);
      } else {
        alert(res?.msg || "Error al guardar.");
      }
    } catch (e) {
      console.error("OP Remitos error:", e?.response?.data || e);
      alert(e?.response?.data?.msg || e.message || "Error al guardar.");
    }
  };

  const nombreProv =
    (proveedor?.razonsocial || proveedor?.nombre || "").toString();
  const nombreCli =
    (cliente?.razonsocial || cliente?.nombre || "")?.toString() || "";

  return (
    <Modal show={show} onHide={() => onHide(false)} size="xl">
      <Modal.Header closeButton>
        <Modal.Title>Nueva Orden de Pago (Remitos)</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {/* headers */}
        <Row className="mb-2">
          <Col md={4}>
            <Form.Label>Proveedor</Form.Label>
            <Form.Control readOnly value={nombreProv} />
          </Col>
          <Col md={4}>
            <Form.Label>Cliente (filtro opcional)</Form.Label>
            <Form.Control readOnly value={nombreCli} placeholder="(sin filtro)" />
            <div className="mt-1">
              <Form.Check
                type="switch"
                id="filtrar-por-cliente"
                label="Filtrar por este cliente"
                checked={filtrarCliente}
                onChange={(e) => setFiltrarCliente(e.target.checked)}
              />
            </div>
          </Col>
          <Col md={4}>
            <Form.Label>Fecha</Form.Label>
            <Form.Control
              type="date"
              value={fecha}
              onChange={(e) => setFecha(e.target.value)}
            />
          </Col>
        </Row>

        {/* pendientes */}
        <Row className="align-items-center mb-2">
          <Col>
            <b>Remitos pendientes del proveedor</b>
          </Col>
          <Col className="text-end">
            <Button size="sm" variant="outline-secondary" onClick={tildarTodas}>
              Tildar todos
            </Button>{" "}
            <Button size="sm" variant="outline-secondary" onClick={destildarTodas}>
              Destildar todos
            </Button>{" "}
            <Button
              size="sm"
              variant="outline-primary"
              onClick={handlePdfPendientes}
            >
              PDF pendientes
            </Button>{" "}
            {Boolean(seleccion.length) && (
              <span className="ms-2">
                Seleccionados: <b>{seleccion.length}</b> — Σ:{" "}
                <b>${$(totalSeleccion)}</b>
              </span>
            )}
          </Col>
        </Row>


        <div
          style={{
            maxHeight: 260,
            overflowY: "auto",
            border: "1px solid #e0e0e0",
            position: "relative",
          }}
        >
          <Table size="sm" bordered hover className="m-0">
            <thead>
              <tr
                style={{
                  position: "sticky",
                  top: 0,
                  background: "#f8f9fa",
                  zIndex: 2,
                }}
              >
                <th style={{ width: 40 }}></th>
                <th>Remito</th>
                <th>Fecha</th>
                <th style={{ textAlign: "right" }}>Pendiente Compra A (blanco + IVA)</th>
                <th style={{ textAlign: "right" }}>Pendiente Compra B (negro)</th>
                <th style={{ textAlign: "right" }}>Pendiente Flete</th>
                <th style={{ textAlign: "right" }}>Saldo</th>
              </tr>
            </thead>
            <tbody>
              {pendientes.map((r) => {
                const checked = !!seleccion.find((x) => x._id === r._id);

                const pendA = Number(
                  r.pendienteA ??
                  Math.max(0, Number(r.totalCompraA || 0) - Number(r.pagadoA || 0))
                );
                const pendB = Number(
                  r.pendienteB ??
                  Math.max(0, Number(r.totalCompraB || 0) - Number(r.pagadoB || 0))
                );
                const pendF = Number(
                  r.pendienteFlete ??
                  Math.max(0, Number(r.flete || 0) - Number(r.pagadoFlete || 0))
                );

                const saldo = Number((pendA + pendB + pendF).toFixed(2));

                const disabled = saldo <= 0.01;
                const id = `sel-r-${r._id}`;

                return (
                  <tr key={r._id} style={disabled ? { opacity: 0.5 } : undefined}>
                    <td style={{ width: 40, textAlign: "center" }}>
                      <input
                        id={id}
                        type="checkbox"
                        className="form-check-input m-0 p-0"
                        disabled={disabled}
                        checked={checked}
                        onChange={() => toggle(r)}
                        onClick={(e) => e.stopPropagation()}
                      />
                    </td>
                    <td>
                      <label htmlFor={id} className="w-100 m-0">
                        #{String(r.codrem).padStart(6, "0")}
                      </label>
                    </td>
                    <td style={{ textAlign: "center" }}>
                      <label htmlFor={id} className="w-100 m-0">
                        {fmtFechaDoc(r.fecha)}
                      </label>
                    </td>
                    <td style={{ textAlign: "right" }}>
                      <label htmlFor={id} className="w-100 m-0">
                        ${$(pendA)}
                      </label>
                    </td>
                    <td style={{ textAlign: "right" }}>
                      <label htmlFor={id} className="w-100 m-0">
                        ${$(pendB)}
                      </label>
                    </td>
                    <td style={{ textAlign: "right" }}>
                      <label htmlFor={id} className="w-100 m-0">
                        ${$(pendF)}
                      </label>
                    </td>
                    <td style={{ textAlign: "right" }}>
                      <label htmlFor={id} className="w-100 m-0">
                        ${$(saldo)}
                      </label>
                    </td>
                  </tr>
                );
              })}
              {!pendientes.length && (
                <tr>
                  <td colSpan={7} className="text-center text-muted">
                    Sin pendientes para este proveedor/cliente
                  </td>
                </tr>
              )}
            </tbody>

          </Table>
        </div>

        {/* RESUMEN PENDIENTE DEL PROVEEDOR */}
        <div
          className="mt-2 p-2 rounded"
          style={{
            backgroundColor: "#e3f2fd",   // azul clarito de fondo
            border: "1px solid #90caf9", // borde azul
            color: "#0d47a1",            // texto azul más fuerte
            fontWeight: "bold",
          }}
        >
          <Row>
            <Col md={3}>
              Σ Pendiente A (blanco + IVA): ${$(totalesPendientes.compraA)}
            </Col>
            <Col md={3}>
              Σ Pendiente B (negro): ${$(totalesPendientes.compraB)}
            </Col>
            <Col md={3}>
              Σ Flete pendiente: ${$(totalesPendientes.flete)}
            </Col>
            <Col md={3}>
              Σ Saldo pendiente total: ${$(totalesPendientes.saldo)}
            </Col>
          </Row>
        </div>

        {/* Qué conceptos va a pagar esta OP */}
        <Row className="mt-2">
          <Col>
            <Form.Check
              inline
              type="checkbox"
              id="paga-a"
              label="Pagar Compra A (blanco)"
              checked={pagaA}
              onChange={(e) => setPagaA(e.target.checked)}
            />
            <Form.Check
              inline
              type="checkbox"
              id="paga-b"
              label="Pagar Compra B (negro)"
              checked={pagaB}
              onChange={(e) => setPagaB(e.target.checked)}
            />
            <Form.Check
              inline
              type="checkbox"
              id="paga-flete"
              label="Pagar Flete"
              checked={pagaFlete}
              onChange={(e) => setPagaFlete(e.target.checked)}
            />
          </Col>
        </Row>

        {/* pagos / retenciones */}
        <Row className="mt-3">
          <Col md={6}>
            <h6>Pagos</h6>
            <Button
              size="sm"
              onClick={() =>
                addMedio({ medio: "transferencia", importe: 0, cuentaBancaria: "" })
              }
            >
              + Transferencia
            </Button>{" "}
            <Button
              size="sm"
              onClick={() =>
                addMedio({ medio: "cheque", importe: 0, carteraId: "", referencia: "" })
              }
            >
              + Cheque
            </Button>{" "}
            <Button
              size="sm"
              onClick={() =>
                addMedio({ medio: "icheq", importe: 0, carteraId: "", referencia: "" })
              }
            >
              + iCheq
            </Button>{" "}
            <Button
              size="sm"
              onClick={() => addMedio({ medio: "efectivo", importe: 0, caja: "" })}
            >
              + Efectivo
            </Button>

            <Table size="sm" className="mt-2">
              <thead>
                <tr>
                  <th>Medio</th>
                  <th>Origen / Datos</th>
                  <th>Importe</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {medios.map((m, i) => {
                  const selCaja = cajas.find(
                    (c) => String(c._id) === String(m.caja)
                  );
                  const selCta = cuentas.find(
                    (c) => String(c._id) === String(m.cuentaBancaria)
                  );
                  const listaCartera =
                    m.medio === "cheque" ? carteraCheques : carteraICheqs;

                  return (
                    <tr key={i}>
                      <td style={{ width: 120 }}>
                        <Form.Select
                          size="sm"
                          value={m.medio}
                          onChange={(e) =>
                            setMedios((p) =>
                              p.map((x, idx) =>
                                idx === i
                                  ? {
                                      ...x,
                                      medio: e.target.value,
                                      caja: "",
                                      cuentaBancaria: "",
                                      carteraId: "",
                                      referencia: "",
                                      importe: 0,
                                    }
                                  : x
                              )
                            )
                          }
                        >
                          <option value="transferencia">Transferencia</option>
                          <option value="cheque">Cheque</option>
                          <option value="icheq">iCheq</option>
                          <option value="efectivo">Efectivo</option>
                        </Form.Select>
                      </td>

                      <td>
                        {m.medio === "efectivo" && (
                          <div className="d-flex gap-2">
                            <Form.Select
                              size="sm"
                              value={m.caja || ""}
                              style={{ minWidth: 260 }}
                              onChange={(e) =>
                                setMedios((p) =>
                                  p.map((x, idx) =>
                                    idx === i
                                      ? { ...x, caja: e.target.value }
                                      : x
                                  )
                                )
                              }
                            >
                              <option value="">-- Caja --</option>
                              {cajas.map((c) => (
                                <option key={c._id} value={c._id}>
                                  {c.descripcion} — Saldo: $
                                  {$(c.saldoActual || 0)}
                                </option>
                              ))}
                            </Form.Select>
                            {selCaja && (
                              <span className="text-muted">
                                Saldo: ${$(selCaja.saldoActual || 0)}
                              </span>
                            )}
                          </div>
                        )}

                        {m.medio === "transferencia" && (
                          <div className="d-flex gap-2">
                            <Form.Select
                              size="sm"
                              value={m.cuentaBancaria || ""}
                              style={{ minWidth: 260 }}
                              onChange={(e) =>
                                setMedios((p) =>
                                  p.map((x, idx) =>
                                    idx === i
                                      ? { ...x, cuentaBancaria: e.target.value }
                                      : x
                                  )
                                )
                              }
                            >
                              <option value="">-- Cuenta --</option>
                              {cuentas.map((c) => (
                                <option key={c._id} value={c._id}>
                                  {(c.banco || c.descripcion || c.alias || c.numero || "Cuenta")} — Saldo: $
                                  {$(c.saldoActual || 0)}
                                </option>
                              ))}

                            </Form.Select>
                            {selCta && (
                              <span className="text-muted">
                                Saldo: ${$(selCta.saldoActual || 0)}
                              </span>
                            )}
                          </div>
                        )}

                        {(m.medio === "cheque" || m.medio === "icheq") && (
                          <div className="d-flex flex-column gap-1">
                            <Form.Select
                              size="sm"
                              value={m.carteraId || ""}
                              style={{ minWidth: 260 }}
                              onChange={(e) => {
                                const id = e.target.value;
                                setMedios((p) =>
                                  p.map((x, idx) => {
                                    if (idx !== i) return x;
                                    const item = listaCartera.find(
                                      (ch) => String(ch._id) === String(id)
                                    );
                                    if (!item) {
                                      return {
                                        ...x,
                                        carteraId: "",
                                        importe: 0,
                                        referencia: "",
                                      };
                                    }
                                    const ref =
                                      item.nroCheque ||
                                      item.idICheq ||
                                      item.referencia ||
                                      "";
                                    return {
                                      ...x,
                                      carteraId: id,
                                      importe: item.importe || 0,
                                      referencia: ref,
                                    };
                                  })
                                );
                              }}
                            >
                              <option value="">
                                -- {m.medio === "cheque" ? "Cheque" : "iCheq"} en
                                cartera --
                              </option>
                              {listaCartera.map((ch) => (
                                <option key={ch._id} value={ch._id}>
                                  {m.medio === "cheque"
                                    ? `Ch ${ch.nroCheque || ""} — $${$(
                                        ch.importe || 0
                                      )} — ${ch.bancoEmisor || ""}`
                                    : `iCheq ${
                                        ch.idICheq || ""
                                      } — $${$(ch.importe || 0)}`}
                                </option>
                              ))}
                            </Form.Select>
                            {m.referencia && (
                              <span className="text-muted">
                                Ref: {m.referencia}
                              </span>
                            )}
                          </div>
                        )}
                      </td>

                      <td style={{ width: 160 }}>
                        <Form.Control
                          size="sm"
                          type="number"
                          step="0.01"
                          value={m.importe}
                          onChange={(e) =>
                            setMedios((p) =>
                              p.map((x, idx) =>
                                idx === i
                                  ? { ...x, importe: Number(e.target.value) }
                                  : x
                              )
                            )
                          }
                        />
                      </td>

                      <td style={{ width: 50 }}>
                        <Button
                          variant="outline-danger"
                          size="sm"
                          onClick={() => rmMedio(i)}
                        >
                          x
                        </Button>
                      </td>
                    </tr>
                  );
                })}
                {!medios.length && (
                  <tr>
                    <td colSpan={4} className="text-muted">
                      Agregá al menos un pago
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>

            {saldoWarnings.length > 0 && (
              <ul className="mt-2" style={{ color: "crimson" }}>
                {saldoWarnings.map((w, i) => (
                  <li key={i}>{w}</li>
                ))}
              </ul>
            )}
          </Col>

          {/* retenciones */}
          <Col md={6}>
            <h6>Retenciones</h6>
            <Button
              size="sm"
              onClick={() =>
                addRet({ tipo: "IIBB", base: 0, porcentaje: 0, importe: 0 })
              }
            >
              + IIBB
            </Button>{" "}
            <Button
              size="sm"
              onClick={() =>
                addRet({ tipo: "GAN", base: 0, porcentaje: 0, importe: 0 })
              }
            >
              + Ganancias
            </Button>{" "}
            <Button
              size="sm"
              onClick={() =>
                addRet({ tipo: "IVA", base: 0, porcentaje: 0, importe: 0 })
              }
            >
              + IVA
            </Button>{" "}
            <Button
              size="sm"
              onClick={() =>
                addRet({ tipo: "OTRA", base: 0, porcentaje: 0, importe: 0 })
              }
            >
              + Otra
            </Button>

            <Table size="sm" className="mt-2">
              <thead>
                <tr>
                  <th>Tipo</th>
                  <th>Base</th>
                  <th>%</th>
                  <th>Importe</th>
                  <th>Comp.</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {rets.map((r, i) => (
                  <tr key={i}>
                    <td>
                      <Form.Select
                        size="sm"
                        value={r.tipo}
                        onChange={(e) =>
                          setRets((p) =>
                            p.map((x, idx) =>
                              idx === i ? { ...x, tipo: e.target.value } : x
                            )
                          )
                        }
                      >
                        <option value="IIBB">IIBB</option>
                        <option value="GAN">Ganancias</option>
                        <option value="IVA">IVA</option>
                        <option value="OTRA">OTRA</option>
                      </Form.Select>
                    </td>
                    <td style={{ width: 110 }}>
                      <Form.Control
                        size="sm"
                        type="number"
                        step="0.01"
                        value={r.base || 0}
                        onChange={(e) =>
                          setRets((p) =>
                            p.map((x, idx) =>
                              idx === i
                                ? { ...x, base: Number(e.target.value) }
                                : x
                            )
                          )
                        }
                      />
                    </td>
                    <td style={{ width: 90 }}>
                      <Form.Control
                        size="sm"
                        type="number"
                        step="0.01"
                        value={r.porcentaje || 0}
                        onChange={(e) =>
                          setRets((p) =>
                            p.map((x, idx) =>
                              idx === i
                                ? { ...x, porcentaje: Number(e.target.value) }
                                : x
                            )
                          )
                        }
                      />
                    </td>
                    <td style={{ width: 120 }}>
                      <Form.Control
                        size="sm"
                        type="number"
                        step="0.01"
                        value={r.importe || 0}
                        onChange={(e) =>
                          setRets((p) =>
                            p.map((x, idx) =>
                              idx === i
                                ? { ...x, importe: Number(e.target.value) }
                                : x
                            )
                          )
                        }
                      />
                    </td>
                    <td style={{ width: 140 }}>
                      <Form.Control
                        size="sm"
                        placeholder="Comprobante"
                        value={r.comprobante || ""}
                        onChange={(e) =>
                          setRets((p) =>
                            p.map((x, idx) =>
                              idx === i
                                ? { ...x, comprobante: e.target.value }
                                : x
                            )
                          )
                        }
                      />
                    </td>
                    <td>
                      <Button
                        variant="outline-danger"
                        size="sm"
                        onClick={() => rmRet(i)}
                      >
                        x
                      </Button>
                    </td>
                  </tr>
                ))}
                {!rets.length && (
                  <tr>
                    <td colSpan={6} className="text-muted">
                      Agregá retenciones si corresponde
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </Col>
        </Row>

        <Row className="mt-2">
          <Col>
            <Form.Label>Observaciones</Form.Label>
            <Form.Control
              as="textarea"
              rows={2}
              value={obs}
              onChange={(e) => setObs(e.target.value)}
            />
          </Col>
        </Row>

        <Row className="mt-3">
          <Col md={3}>
            <b>Σ Selección:</b> ${$(totalSeleccion)}
          </Col>
          <Col md={3}>
            <b>Σ Pagos:</b> ${$(totalPagos)}
          </Col>
          <Col md={3}>
            <b>Σ Retenciones:</b> ${$(totalRets)}
          </Col>
          <Col md={3}>
            <b>Σ Aplicable:</b> ${$(montoAplicable)}
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <div className="text-muted">
              Diferencia (Selección − Aplicable):{" "}
              <b
                style={{
                  color:
                    Math.abs(Number(diferenciaVisual)) <= 0.01
                      ? "green"
                      : "crimson",
                }}
              >
                {$(diferenciaVisual)}
              </b>{" "}
              (informativa)
            </div>
            {aplicacionesDistribuidas.restante > 0.01 && (
              <div className="text-danger mt-1">
                * Hay importe sin poder aplicarse por falta de saldo seleccionado.
              </div>
            )}
          </Col>
        </Row>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={() => onHide(false)}>
          Cancelar
        </Button>
        <Button variant="primary" onClick={guardar} disabled={!canSubmit}>
          Guardar
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
